import JsonApiFilterManager from "@/lib/JsonApiFilterManager";
import raftGenericHelper from "@/lib/raft_generic_helper";
import { jsonClient } from "@/lib/raftApi";
import axios from "axios";
import { useNotification } from "./useNotification";

// eslint-disable-next-line import/prefer-default-export
export function useMessaging() {
  const { showNotification } = useNotification();

  const setBaseMessageFilters = (pageLimit = 25) => {
    const baseQueries = {
      include: "from_user,to,message_template,message_builder",
      sort: "-changed",
    };
    JsonApiFilterManager.queries = baseQueries;
    JsonApiFilterManager.queries["page[limit]"] = pageLimit;
    JsonApiFilterManager.addFilter("status", "status", "1");
    JsonApiFilterManager.addFilter(
      "sent_timestamp",
      "sent_timestamp",
      "0",
      "<>",
    );
    JsonApiFilterManager.setSortFields("-sent_timestamp");
  };

  const setFromUserFilter = (user) => {
    JsonApiFilterManager.addFilter(
      "from",
      "from_user.drupal_internal__uid",
      user.drupal_internal__uid,
    );
  };

  const setUserInboxQueries = (user) => {
    // From MessageList.vue, user is an object called from /jsonapi/user/user filter
    // From User Inbox Block.vue, user is a uid as string
    let userUid = null;
    if (typeof user === "number" || typeof user === "string") {
      userUid = user;
    }
    if (typeof user === "object" && user.drupal_internal__uid) {
      userUid = user.drupal_internal__uid;
    }
    // TO
    JsonApiFilterManager.addFilter(
      "u_to",
      "to.meta.drupal_internal__target_id",
      userUid,
    );
    JsonApiFilterManager.setUpdateFilters();
  };

  const fetchMessages = async () => {
    const options = {
      path: "message/message",
      queries: JsonApiFilterManager.queries,
    };
    const response = await jsonClient
      .cancelRequest(options.path)
      .get(options)
      .catch((e) => {
        if (!axios.isCancel(e)) {
          showNotification("error", e.message);
        } else {
          return "canceled";
        }
      });
    return response || [];
  };

  const dateSentFormatter = (value) => {
    if (!value || value === "1970-01-01T00:00:00+00:00") {
      return "--";
    }
    return raftGenericHelper.formatDateTime(new Date(value));
  };

  return {
    setUserInboxQueries,
    fetchMessages,
    setFromUserFilter,
    setBaseMessageFilters,
    dateSentFormatter,
  };
}
